import React from 'react';

const ReportedItems = () => {
    return (
        <div>
            <h2 className='mt-24'>reported items</h2>
        </div>
    );
};

export default ReportedItems;